@if (isPro && className) {
    <span>
        <span
                [class]="className"
                (mouseenter)="handleTooltip($event)"
                (mouseleave)="hideTooltip()">
        </span>
        <span
                class="description"
                [innerHTML]="description"
                [style.left.px]="tooltipPosition.left"
                [style.top.px]="tooltipPosition.top"
                [style.visibility]="tooltipVisible ? 'visible' : 'hidden'">
        </span>
    </span>
}